import GalleryWrapper from "../../../../src/components/gallery/gallery-wrapper";
import { graphql } from 'gatsby';
import * as React from 'react';
export default {
  GalleryWrapper,
  graphql,
  React
};